// extracted by mini-css-extract-plugin
module.exports = {"message":"PromotionalMessages_message__LXO5R","messageLink":"PromotionalMessages_messageLink__GNuaz"};